<template>
    <v-app>
        <v-app-bar
            app
            color="#4f4f4f"
            dark
            absolute
            elevate-on-scroll
        >
            <v-app-bar-nav-icon 
                v-if="user.id"
                @click.stop="drawer = !drawer" />
            <v-spacer />
            <v-menu
                v-if="user.id"
                offset-y
                left
                nudge-bottom="8"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        text
                        dark
                        class="text-none"
                        v-bind="attrs"
                        v-on="on"
                    >
                        {{ userDisplayName }}
                        <v-icon right small>mdi-chevron-down</v-icon>
                    </v-btn>
                </template>
                <v-list min-width="220">
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle>Телефон</v-list-item-subtitle>
                            <v-list-item-title>{{ user.phone }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-btn
                            block
                            color="error"
                            @click="logout"
                        >Выйти</v-btn>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <v-main>
            <v-navigation-drawer
                v-model="drawer"
                absolute
                temporary
                class="admin-sidebar"
            >
                <v-list nav>
                    <v-list-item-group>
                        <v-list-item @click="$router.push({ name: 'orders-list' })">
                            <v-list-item-title>Заказы</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'sites-list' })">
                            <v-list-item-title>Рестораны</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="$router.push({ name: 'discounts-list' })">
                            <v-list-item-title>Акции и скидки</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="$router.push({ name: 'collections-list' })">
                            <v-list-item-title>Коллекции сайтов</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="$router.push({ name: 'news-list' })">
                            <v-list-item-title>Новости</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="$router.push({ name: 'users-list' })">
                            <v-list-item-title>Пользователи</v-list-item-title>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-navigation-drawer>
            <div class="ma-4">
                <router-view />
            </div>
        </v-main>
    </v-app>
</template>

<script>
    import store from '@/store';
    import { mapState } from 'vuex';

    export default {
        name: 'App',

        data: () => ({
            drawer: null,
        }),
        computed: {
            ...mapState('auth', ['user']),
            userDisplayName() {
                const name = [this.user.firstname, this.user.lastname]
                    .filter(Boolean)
                    .join(' ')
                    .trim();
                return name || this.user.phone || '';
            },
        },
        async mounted() {
            if(!this.user.id) {
                await store.dispatch('auth/fetch');
                if (!this.user.id) {
                    await this.$router.push({ name: 'user-authorization' });
                }
            }
        },
        methods: {
            async logout() {
                await store.dispatch('auth/logout');
                await this.$router.push({ name: 'user-authorization' });
            }
        }
    };
</script>